<template>
  <div class="wrapper">
    <div id="payments">
      <el-row :gutter="18">
        <el-col v-if="client" :span="11">
          <BillingCosts :customer="customer" @change-product="upgrade = true" />
        </el-col>

        <el-col v-if="!loading" :span="span">
          <BillingPaymentMethod
            :customer.sync="customer"
            :payment-default="paymentDefault"
            :payment-methods="paymentMethods"
            @change="load"
          />
        </el-col>
      </el-row>

      <h2>Billing history</h2>
    </div>

    <el-table v-loading="loading" :data="history" size="small">
      <el-table-column width="38px" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.paid" class="mdi mdi-check-circle" />
        </template>
      </el-table-column>

      <el-table-column label="Amount" prop="amount_due">
        <template slot-scope="scope">
          {{ $root.currency.symbol }}{{ scope.row.amount_due.toString().padStart(3, 0).replace(/([0-9]{2})$/, '.$1') }}
        </template>
      </el-table-column>

      <el-table-column label="Invoice Number" prop="number" />

      <el-table-column label="Created" prop="created">
        <template slot-scope="scope">
          {{ toCalendar(scope.row.created) }}
        </template>
      </el-table-column>

      <el-table-column align="center">
        <template v-if="scope.row.invoice_pdf" slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click.prevent="download(scope.row.invoice_pdf)"
          >
            <i class="mdi mdi-download" />
            Download PDF
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination v-if="false" />

    <el-dialog
      custom-class="billing-upgrade-popup"
      title="Upgrade your account"
      :visible.sync="upgrade"
    >
      <BillingUpgrade @upgrade="upgrade = false" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Pagination from '../components/Pagination'
import BillingCosts from '../components/Billing/Costs'
import BillingPaymentMethod from '../components/Billing/PaymentMethod'
import BillingUpgrade from '../components/Billing/Upgrade'

export default {
  components: {
    Pagination,
    BillingCosts,
    BillingPaymentMethod,
    BillingUpgrade
  },
  data () {
    return {
      defaultSort: {
        prop: 'created',
        order: 'descending'
      },
      loading: false,
      upgrade: this.$route.query.upgrade || false,
      customer: null,
      paymentMethods: [],
      paymentDefault: null,
      page: 1,
      total: 1,
      history: []
    }
  },
  created () {
    if (this.client) {
      this.load()
      this.loadHistory()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    span () {
      return this.client ? 13 : 24
    },
    ...mapState(['client', 'project']),
    ...mapGetters(['permission'])
  },
  methods: {
    load () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$store.dispatch('getBilling').then((result) => {
        this.loading = false
        this.customer = result.customer
        this.paymentMethods = result.paymentMethods
        this.paymentDefault = result.customer.invoice_settings.default_payment_method

        if (result.customer.metadata[this.project.id]) {
          const pm = this.paymentMethods.find((pm) => pm.id === result.customer.metadata[this.project.id])
          if (pm) {
            this.paymentDefault = pm.id
          }
        }
      }).catch(() => {})
    },
    loadHistory () {
      this.$store.dispatch('getBillingHistory').then((history) => {
        this.history = history.data
      }).catch(() => {})
    },
    download (pdf) {
      window.open(pdf, '_blank')
    }
  },
  beforeMount () {
    if (!this.permission('owner') && !this.permission('admin') && !this.permission('accounting')) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  #payments {
    padding-top: 18px;

    h2 {
      margin-top: 48px;
    }
  }

  .mdi-check-circle {
    color: $--color-success;
  }
</style>

<style lang="scss">
  .billing-upgrade-popup {
    width: calc(100% - 20px);
    max-width: 1000px;

    .el-dialog__body {
      padding-top: 10px;
    }
    .el-dialog__header span {
      font-weight: bold;
      font-size: 20px;
    }
  }
</style>
